import { render } from "./ModalFormIndices.vue?vue&type=template&id=fef71ef2&scoped=true"
import script from "./ModalFormIndices.vue?vue&type=script&lang=js"
export * from "./ModalFormIndices.vue?vue&type=script&lang=js"

import "./ModalFormIndices.vue?vue&type=style&index=0&id=fef71ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef71ef2"]])

export default __exports__